import React from "react";
import GatsbyLink from "../GatsbyLink";
import "./Logo.scss";

export const Logo = () => {
  return (
    <GatsbyLink to="/" className="logo-link" aria-label="Logo">
      <svg
        width="140"
        height="50"
        viewBox="0 0 560 194"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        overflow="visible"
      >
        <path
          d="M432.264 83.1025V117.354H466.648C469.448 117.354 471.744 119.656 471.744 122.464V124.598C472.192 133.863 469.168 142.959 463.232 150.034C459.872 153.571 455.728 156.379 451.192 158.232C446.656 160.085 441.784 160.927 436.856 160.759C432.432 160.927 428.008 160.141 423.92 158.4C419.832 156.716 416.136 154.077 413.168 150.82C406 142.79 404.096 133.694 404.096 96.9717C404.096 60.2492 405.944 51.4336 413.168 43.4041C416.136 40.0912 419.832 37.4521 423.92 35.7115C428.008 33.9708 432.432 33.1285 436.856 33.2409C455.728 33.2409 466.648 43.1233 470.904 61.0915H508.2C503.104 28.9734 480.76 -0.0002481 436.8 -0.0002481C427.336 -0.22485 417.872 1.51582 409.08 5.0533C400.288 8.64693 392.336 14.0374 385.672 20.8877C366.52 40.1474 367.024 64.0113 367.024 96.9717C367.024 129.932 366.464 153.74 385.672 173.056C392.336 179.85 400.288 185.184 409.08 188.778C417.872 192.371 427.28 194.112 436.8 193.944C446.712 194.337 456.624 192.596 465.864 188.89C475.104 185.128 483.448 179.457 490.28 172.269C503.552 158.344 508.368 141.724 508.368 114.154V83.1025H432.208H432.264ZM135.184 0.842009L89.824 95.8487C88.256 99.1054 83.608 99.1054 82.04 95.8487L36.456 0.842009H0V190.518H36.96V86.1908C36.96 84.7309 38.92 84.2817 39.536 85.5731L73.416 152.785H98.448L132.048 85.6293C132.72 84.3378 134.624 84.787 134.624 86.2469V191.585H171.64V0.842009H135.184ZM307.832 0.842009V112.975C307.832 114.322 306.04 114.884 305.312 113.705L232.792 0.842009H199.752V191.529H236.768V79.172C236.768 77.8244 238.56 77.2628 239.288 78.442L311.808 191.585H344.848V0.842009H307.832Z"
          fill="white"
        />
        <g className="shift">
          <path
            d="M560.001 152.842H521.977V191.473H560.001V152.842Z"
            fill="#F15A29"
          />
        </g>
      </svg>
    </GatsbyLink>
  );
};
